import GDropdown from './GDropdownOld.vue';

export default GDropdown;

export { GDropdown };
